// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-container {
  max-width: 950px;
  margin: 2rem auto;
  padding: 2rem;
  background: #f8f8f8;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  line-height: 1.8;
  color: #333;
}

.about-logo {
  text-align: center;
  margin-bottom: 1rem;
}

.about-logo img {
  height: 90px;
  width: 90px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
}

.about-container h1 {
  text-align: center;
  color: #00703C;
  margin-bottom: 1rem;
}

.about-container p {
  font-size: 1rem;
  margin-bottom: 1rem;
  text-align: justify;
}

.about-container strong {
  color: #00703C;
}

/* ===== Core Values Section ===== */
.core-values {
  margin-top: 2rem;
  text-align: center;
}

.core-values h2 {
  color: #00703C;
  margin-bottom: 1.5rem;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.value-card {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
  transition: transform 0.2s ease, box-shadow 0.3s ease;
}

.value-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

.value-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.value-card h3 {
  color: #00703C;
  margin-bottom: 0.5rem;
}

.value-card p {
  color: #555;
  font-size: 0.95rem;
}

/* ===== Responsive ===== */
@media (max-width: 600px) {
  .about-container {
    padding: 1rem;
  }

  .values-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".about-container {\n  max-width: 950px;\n  margin: 2rem auto;\n  padding: 2rem;\n  background: #f8f8f8;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  line-height: 1.8;\n  color: #333;\n}\n\n.about-logo {\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.about-logo img {\n  height: 90px;\n  width: 90px;\n  border-radius: 50%;\n  background: white;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\n}\n\n.about-container h1 {\n  text-align: center;\n  color: #00703C;\n  margin-bottom: 1rem;\n}\n\n.about-container p {\n  font-size: 1rem;\n  margin-bottom: 1rem;\n  text-align: justify;\n}\n\n.about-container strong {\n  color: #00703C;\n}\n\n/* ===== Core Values Section ===== */\n.core-values {\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.core-values h2 {\n  color: #00703C;\n  margin-bottom: 1.5rem;\n}\n\n.values-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.value-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.08);\n  transition: transform 0.2s ease, box-shadow 0.3s ease;\n}\n\n.value-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 12px rgba(0,0,0,0.15);\n}\n\n.value-icon {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.value-card h3 {\n  color: #00703C;\n  margin-bottom: 0.5rem;\n}\n\n.value-card p {\n  color: #555;\n  font-size: 0.95rem;\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 600px) {\n  .about-container {\n    padding: 1rem;\n  }\n\n  .values-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
